import { Layout } from '@components/common'
import { Container, Heading2 } from '@components/ui'
import { Grid, Column } from '@components/common'
import SEO from '@components/common/SEO/SEO'

export default function ReturnRefundPolicy() {
  return (
    <Container>
      {/* Using Grid to Add Top/Bottom Padding w/o Creating a New Component */}
      <Grid xsGutter={30}>
        <Column xs={12}>
          <Heading2>Return & Refund Policy</Heading2>
          <p>
            You may make a return on most new, <strong>unopened</strong> items
            within 30 days of delivery excluding any discount and
            handling/shipping charges. We will pay for the shipping costs if the
            return is a result of our error (you received an incorrect item). In
            some cases a restocking fee of 10% will be applied for unopened
            items if the original packaging is not in re-sellable condition.
          </p>
          <p>
            <strong>Opened items and/or installed items</strong> require prior
            authorization for returns. All electrical items are inspected by our
            vendor warranty managers. Incorrectly installed/wired products will
            not qualify for refunds. Returned product serial numbers must match
            the serial numbers that we shipped.
          </p>
          <p>
            Most refunds are processed within four weeks of your package being
            given to the return shipper.
          </p>
          <p>
            If you need to return an item, simply login to your account, view
            the order using the "Complete Orders" link under the My Account menu
            and click the Return Item(s) button. We'll notify you via e-mail of
            your refund once we've received and processed the returned item.
          </p>
        </Column>
      </Grid>
      <SEO
        title={'Return & Refund Policy'}
        description={'Return & refund policy for TS Pool Supply.'}
        openGraph={{
          type: 'website',
          title: 'Return & Refund Policy',
          description: 'Return & Refund Policy',
          images: [
            {
              url: '/static_images/ts-pool-supply-og-pool.jpg',
              width: 1280,
              height: 720,
              alt: 'TS Pool Supply',
            },
          ],
        }}
      ></SEO>
    </Container>
  )
}

ReturnRefundPolicy.Layout = Layout
